function Home({ onStartTest, onLogin, isPremium }) {
  const premiumClick = () => {
    if (isPremium) {
      alert("✅ Premium Feature Open");
    } else {
      alert("🔒 Please Buy Premium Membership");
    }
  };

  return (
    <>
      <h2>Welcome</h2>

      <p>
        Prepare Smart. Score High. Achieve Your Railway LDCE Mechanical JE Goal.
      </p>

      <h2>India's Best Railway LDCE Mechanical JE Test Series</h2>

      <button onClick={onStartTest}>
        📝 Start Free Mock Test
      </button>

      <button onClick={onLogin}>
        🔐 Login
      </button>

      <button>
        💎 Buy Premium Test Series
      </button>

      <a
        href="/app-debug-google.apk"
        download
        style={{
          display: "inline-block",
          margin: "10px",
          padding: "12px 20px",
          background: "#1976d2",
          color: "white",
          textDecoration: "none",
          borderRadius: "8px",
          fontWeight: "bold"
        }}
      >
        📱 Download Android App
      </a>

      <div className="features">

        <div
          className="card"
          onClick={premiumClick}
          style={{ cursor: "pointer" }}
        >
          <h3>
            📚 Topic Wise Tests {isPremium ? "✅" : "🔒"}
          </h3>
          <p>
            {isPremium ? "Unlimited Access" : "Premium Members Only"}
          </p>
        </div>

        <div
          className="card"
          onClick={premiumClick}
          style={{ cursor: "pointer" }}
        >
          <h3>
            📝 Full Mock Tests {isPremium ? "✅" : "🔒"}
          </h3>
          <p>
            {isPremium ? "Unlimited Access" : "Premium Members Only"}
          </p>
        </div>

        <div
          className="card"
          onClick={premiumClick}
          style={{ cursor: "pointer" }}
        >
          <h3>
            📄 Previous Year Papers {isPremium ? "✅" : "🔒"}
          </h3>
          <p>
            {isPremium ? "Unlimited Access" : "Premium Members Only"}
          </p>
        </div>

        <div
          className="card"
          onClick={premiumClick}
          style={{ cursor: "pointer" }}
        >
          <h3>
            📖 PDF Notes {isPremium ? "✅" : "🔒"}
          </h3>
          <p>
            {isPremium ? "Unlimited Download" : "Premium Members Only"}
          </p>
        </div>

      </div>
    </>
  );
}

export default Home;
